"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserCarriers {
}
exports.UserCarriers = UserCarriers;
//# sourceMappingURL=UserCarriers.js.map